<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    uppercase
                    v-model="model.nome"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    :options="form.conectasusGrupos"
                    @change="model.conectasusMaterial = null"
                    default-option-text="Todos"
                    label="Grupo (ConectaSUS)"
                    show-default-option
                    text-field="nome"
                    v-model="model.conectasusMaterialGrupoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="8">
                <rkm-form-input-autocomplete
                    :repository="repositories.cadastroMaterial"
                    :request-query-string-params="{grupo_id: model.conectasusMaterialGrupoId}"
                    :search-fields="fields.conectasusMaterial"
                    label="Material (ConectaSUS)"
                    text-field="descricaoCompleta"
                    uppercase
                    v-model="model.conectasusMaterial"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
            }
        },
        fields() {
            return {
                conectasusMaterial: [
                    { key: 'codigo_material', searchable: true },
                    { key: 'descricao', searchable: true },
                ],
            }
        },
    },
    created() {
        this.repositories = {
            cadastroGrupo: this.getConectaSusRepository('cadastro.grupo'),
            cadastroMaterial: this.getConectaSusRepository('cadastro.material'),
            material: this.getConectaSusRepository('webService.almoxarifado.cliente.material'),
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.material.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.material.create()
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        nome: this.model.nome,
                        conectasusMaterialId: this.model.conectasusMaterial?.id ?? null,
                    }

                    if (this.id) {
                        this.repositories.material.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {
                        this.repositories.material.store(this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>